import React, { useEffect, useState } from 'react';
import './styles.css'
import NotificationToast from './components/notification/NotificationToast';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import ReturRefundPolicy from './components/sections/ReturnandRefundPolicy';
import CosmicOrbitLoader from '../components/CosmicOrbitLoader';
import { dynamicLoader } from '../helpers/helpers';

const ReturnandRefundPolicy = () => {
  const [showPreloader, setShowPreloader] = useState(true);
  document.title = "Webs2PDF";
  useEffect(() => {
    dynamicLoader.addScripts();
    setTimeout(() => {
      setShowPreloader(false);
    }, 3000);
  });
  if (showPreloader) {
    return <CosmicOrbitLoader />;
  }
  return (
    <>
      <NotificationToast />
      <Navbar isIndex={false} />
      <ReturRefundPolicy />
      <Footer />
    </>
  );
};

export default ReturnandRefundPolicy;
